import { http } from './http';

export type LoginResponse = {
  accessToken: string;
  user: { id: string; email: string; fullName: string; role: string };
};

export const authApi = {
  login: (email: string, password: string) =>
    http<LoginResponse>('/auth/login', {
      method: 'POST',
      body: JSON.stringify({ email, password }),
    }),

  register: (email: string, password: string, fullName: string) =>
    http<LoginResponse>('/auth/register', {
      method: 'POST',
      body: JSON.stringify({ email, password, fullName }),
    }),

  forgotPassword: (email: string) =>
    http<{ message: string }>('/auth/forgot-password', {
      method: 'POST',
      body: JSON.stringify({ email }),
    }),

  resetPassword: (token: string, newPassword: string) =>
    http<{ message: string }>('/auth/reset-password', {
      method: 'POST',
      body: JSON.stringify({ token, newPassword }),
    }),

  getProfile: (token: string | null) =>
    http<{ id: string; email: string; fullName: string; role: string; locale: string; address: string }>(
      '/auth/profile',
      { method: 'GET' },
      token
    ),

  updateProfile: (
    token: string | null,
    data: {
      fullName?: string;
      email?: string;
      locale?: string;
      address?: string;
      oldPassword?: string;
      newPassword?: string;
    }
  ) =>
    http<{ id: string; email: string; fullName: string; role: string; locale: string; address: string }>(
      '/auth/profile',
      { method: 'PATCH', body: JSON.stringify(data) },
      token
    ),
};

